export enum ScenarioUpdateEnum {
  RENAME,
  CONFIG,
  CLONE,
}
